export default __webpack_public_path__ + "static/media/KOD0150-min.bd234d27.webp";